import { ITableColumn, TableColumnTypeEnum, WidthType } from './tableColumn.interface';

export const issueFindingsViolationsTableColumns: ITableColumn[] = [
  {
    propertyKey: 'name',
    labelPath: 'issuePage.gridColumns.name',
    colType: TableColumnTypeEnum.Text,
    width: 300,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'name',
  },
  {
    propertyKey: 'type',
    labelPath: 'issuePage.gridColumns.type',
    colType: TableColumnTypeEnum.Text,
    width: 100,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'type',
  },
  {
    propertyKey: 'severity',
    labelPath: 'issuePage.gridColumns.severity',
    colType: TableColumnTypeEnum.SeverityLabel,
    width: 120,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'severity',
  },
  {
    propertyKey: 'timestamp',
    labelPath: 'issuePage.gridColumns.timestamp',
    colType: TableColumnTypeEnum.Text,
    width: 150,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'timestamp',
  },
  {
    propertyKey: 'user',
    labelPath: 'issuePage.gridColumns.user',
    colType: TableColumnTypeEnum.Text,
    width: 150,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'user',
  },
  {
    propertyKey: 'ruleTags',
    labelPath: 'issuePage.gridColumns.ruleTags',
    colType: TableColumnTypeEnum.Tag,
    width: 200,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
];
